<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('removeEndpoints') >= 0,
        'last-active': opened.indexOf('removeEndpoints') === opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleEndpointAddConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="removeEndpoints()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("odebratZeSkupiny") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="devices">
          {{ $filters.firstUpper($t("odebrat")) }} {{ $t("EndpointOd") }}
          {{ devices.length }}
          {{
            $filters.inflection(
              devices.length,
              $t("inflection_od_1_Skupina"),
              $t("inflection_od_2_4_Skupina"),
              $t("inflection_od_5_Skupina")
            )
          }}
        </h2>
      </div>
      <FormSelectMultiple
        :items="loadedEndpoints"
        :value="selectedEndpoints"
        item-text="custDestName"
        item-value="custDestId"
        :label="$t('odebratEndpointy')"
        :placeholder="$t('vyberteEndpoint')"
        side-box
        @change="selectedEndpoints = $event"
      />
    </div>
    <SaveConfirmationModal
      :opened="openedEndpointAddConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleEndpointAddConfirmation"
      @no="closeBox('removeEndpoints')"
      @yes="removeEndpoints()"
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue"
import { useProjectStore } from "@/store/modules/project"

export default {
  components: {
    FormSelectMultiple,
    SaveConfirmationModal,
    ErrorModal
  },
  props: {
    tags: Array,
    devices: Array,
    opened: Array
  },
  emits: ["updateItems", "closeBox", "openBox"],
  setup() {
    const projectStore = useProjectStore()

    return { projectStore }
  },
  data() {
    return {
      loadedEndpoints: [],
      selectedEndpoints: [],
      groupsOpened: false,
      parametersTagsOpened: false,
      parametersOpened: false,
      selectedParameters: [],
      tagsOpened: false,
      selectedEndpointTags: [],
      groupTags: [],
      writtenEndpointTags: "",
      openedEndpointAddConfirmation: false,
      openedEndpointConfirmation: false,
      errors: {
        endpoint: "",
        group: ""
      },
      selectEndpointVisible: false,
      errorsToTranslate: [],
      openedError: false
    }
  },
  computed: {
    project() {
      return this.projectStore.selectedProject
    }
  },
  watch: {
    project() {
      if (this.project && this.opened.indexOf("removeEndpoints") > -1) {
        this.loadEndpoints()
      }
    },
    writtenEndpointTags() {
      this.createTagsArray()
    },
    opened() {
      if (this.opened.indexOf("removeEndpoints") > -1) {
        this.loadEndpoints()
      }
    }
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === undefined) {
        this.resetForm()
        this.$emit("closeBox")
      } else {
        this.resetForm()
        this.$emit("closeBox", box)
      }
    },
    resetForm() {
      this.selectedEndpoints = []
      this.groupsOpened = false
    },
    loadEndpoints() {
      this.loadedEndpoints = []
      axios
        .get(process.env.VUE_APP_API + "/http/endpoints?search=" + this.project.projectId + "&limit=1000", {})
        .then((result) => {
          this.devices.forEach((group) => {
            result.data.data.forEach((endpoint) => {
              if (endpoint.deviceGroups.filter((e) => e.deviceGroupId === group.deviceGroupId).length > 0) {
                if (this.loadedEndpoints.indexOf(endpoint) === -1) this.loadedEndpoints.push(endpoint)
              }
            })
          })
        })
        .catch(() => {})
    },
    addRemoveEndpoint(group) {
      if (this.selectedEndpoints.indexOf(group) === -1) {
        this.selectedEndpoints.push(group)
      } else {
        this.selectedEndpoints.splice(this.selectedEndpoints.indexOf(group), 1)
      }
      //
    },
    addRemoveParameter(parameter) {
      if (this.selectedParameters.indexOf(parameter) === -1) {
        this.selectedParameters.push(parameter)
      } else {
        this.selectedParameters.splice(this.selectedParameters.indexOf(parameter), 1)
      }
    },
    addRemoveTag(tag) {
      if (this.writtenEndpointTags.indexOf(tag) === -1) {
        this.writtenEndpointTags += tag
      }
    },
    createTagsArray() {
      let written = this.writtenEndpointTags.split(",")
      let selected = []
      written.forEach((tag) => {
        let trimmed = tag.trim()
        selected.push(trimmed)
      })
      this.selectedEndpointTags = selected
    },
    removeEndpoints() {
      this.errorsToTranslate = []
      let promises = []
      let notifications = []
      this.selectedEndpoints.forEach((endpoint) => {
        this.devices.forEach((device) => {
          if (endpoint.deviceGroups.filter((e) => e.deviceGroupId === device.deviceGroupId).length > 0) {
            promises.push(
              axios
                .delete(
                  process.env.VUE_APP_API +
                    "/device-groups/" +
                    device.deviceGroupId +
                    "/endpoints/" +
                    endpoint.custDestId +
                    "/assign",
                  {}
                )
                .then(() => {
                  notifications.push({
                    text: "notificationEndpointGroupRemove",
                    error: false,
                    params: {
                      custDestId: endpoint.custDestId,
                      custDestName: endpoint.custDestName,
                      deviceGroupId: device.deviceGroupId,
                      deviceGroupName: device.deviceGroupName
                    }
                  })
                })
                .catch((error) => {
                  this.errorsToTranslate.push(error.data)
                })
            )
          }
        })
      })
      Promise.all(promises).then(() => {
        this.openedError = true
        this.$store.commit("modals/setGlobalNotification", notifications)
        this.$emit("updateItems")
        this.closeBox("removeEndpoints")
      })
    },
    getAllTags() {
      this.groupTags = _(this.loadedEndpoints)
        .flatMap((f) => f.tags)
        .sortedUniq()
        .value()
    },
    toggleEndpointAddConfirmation() {
      this.openedEndpointAddConfirmation = !this.openedEndpointAddConfirmation
    },
    toggleEndpointConfirmation() {
      this.openedEndpointConfirmation = !this.openedEndpointConfirmation
    }
  }
}
</script>

<style lang="scss" scoped></style>
